/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apartment_Amenities_HeadingInputs */

const en_apartment_amenities_heading = /** @type {(inputs: Apartment_Amenities_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What's Included`)
};

/**
* | output |
* | --- |
* | "What's Included" |
*
* @param {Apartment_Amenities_HeadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const apartment_amenities_heading = /** @type {((inputs?: Apartment_Amenities_HeadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apartment_Amenities_HeadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_apartment_amenities_heading(inputs)
});